import firebase from 'firebase';

import { MEDIA } from '../collectionTypes';
import { processQuerySnapshotItems } from './utils';

const db = firebase.firestore();
const collection = db.collection(MEDIA);

export function getPostMedia(postId) {
  return collection
    .where('postId', '==', postId)
    .orderBy('order')
    .get()
    .then(processQuerySnapshotItems);
}

export function createMedia(media) {
  return collection.add(media);
}

export function updateMedia(id, media) {
  return collection.doc(id).set(media);
}

export function deleteMedia(id) {
  return collection.doc(id).delete();
}



// WEBPACK FOOTER //
// ./src/firebase/repositories/media.js